<template>
    <transition name="fade" appear>
        <div
            tabindex="-1"
            class="custom-modal animate-in"
        >
            <button
                @click="close"
                class="custom-modal-bg"
            />
            <button
                @click="close"
                aria-label="Close modal"
                class="custom-modal-close hover-opacity"
            >
                &times;
            </button>

            <div class="custom-modal-box">
                <div class="custom-modal-box-content">
                    <slot />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapMutations } from 'vuex';

    export default {
        name: 'Modal',
        data() {
            return {
                mainContent: document.querySelector('.main'),
            };
        },
        async mounted() {
            await this.$nextTick();

            this.mainContent.style.top = -window.pageYOffset + 'px';
            document.body.classList.add('custom-modal-open');

            window.scrollTo(0, 0);

            document.addEventListener('keyup', (e) => {
                if (e.key === 'Escape') this.close();
            });
        },
        destroyed() {
            const scrollOffset = Math.abs(parseFloat(this.mainContent.style.top));

            document.body.classList.remove('custom-modal-open');
            document.removeEventListener('keyup', this.close);

            this.mainContent.style.removeProperty('top');

            window.scrollTo(0, scrollOffset, { duration: 0 });
        },
        methods: {
            ...mapMutations('modal', [
                'setModal',
            ]),

            close() {
                this.setModal({ name: null });
                this.$emit('close');
            },
        },
    };
</script>

<style lang="scss">
    .custom-modal {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        z-index: 300;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-height: 100vh;

        &-bg {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            background-color: rgba($alto, 0.7);
        }

        &-box {
            position: relative;
            z-index: 2;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            width: 100%;
            background: #000;
            box-shadow: 1px 1px 2px rgba(#000, 0.05);

            @include respond-to(md) {
                flex-grow: 0;
                max-width: 850px;
                margin: 32px auto;
            }

            @include respond-to(lg) {
                max-width: 950px;
            }

            @include respond-to(xl) {
                max-width: 1050px;
            }
        }

        &-close {
            position: absolute;
            top: 8px;
            right: 8px;
            z-index: 3;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            font-size: 24px;
            line-height: 48px;
            color: #fff;
            text-align: center;
            background-color: $thunder;
            border: 0;
            transition: color 0.3s;

            @include respond-to(lg) {
                top: 16px;
                right: 16px;
            }
        }
    }
</style>
